import React, { type ReactNode } from 'react'

function LinkedinLogoIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="var(--color-icon-social)"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18.25 0.594727H1.70703C0.976562 0.594727 0.375 1.23926 0.375 2.0127V18.4697C0.375 19.2432 0.976562 19.8447 1.70703 19.8447H18.25C18.9805 19.8447 19.625 19.2432 19.625 18.4697V2.0127C19.625 1.23926 18.9805 0.594727 18.25 0.594727ZM6.17578 17.0947H3.33984V7.94238H6.17578V17.0947ZM4.75781 6.65332C3.8125 6.65332 3.08203 5.92285 3.08203 5.02051C3.08203 4.11816 3.8125 3.34473 4.75781 3.34473C5.66016 3.34473 6.39062 4.11816 6.39062 5.02051C6.39062 5.92285 5.66016 6.65332 4.75781 6.65332ZM16.875 17.0947H13.9961V12.626C13.9961 11.5947 13.9961 10.2197 12.5352 10.2197C11.0312 10.2197 10.8164 11.3799 10.8164 12.583V17.0947H7.98047V7.94238H10.6875V9.18848H10.7305C11.1172 8.45801 12.0625 7.68457 13.4375 7.68457C16.3164 7.68457 16.875 9.61816 16.875 12.0674V17.0947Z" />
    </svg>
  )
}

export default LinkedinLogoIcon
